import Vue from "vue";
import VueResource from "vue-resource";
import Router from "vue-router";

import profile from "@/components/profile";
import event from "@/components/event/index";
import dashboard from "@/components/dashboard/index";
import registration from "@/components/registration";
import eventCreationPrompt from "@/components/dashboard/eventCreationPrompt";
import eventDetails from "@/components/event/details";
import eventAttendees from "@/components/event/attendees";
import eventSessions from "@/components/event/schedule";
import eventHome from "@/components/event/home";

Vue.use(VueResource);
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/eventcreate",
      component: eventCreationPrompt,
      meta: { showLoginPrompt: true }
    },
    {
      path: "/dashboard",
      component: dashboard,
      meta: { showLoginPrompt: true }
    },
    {
      path: "/signup",
      component: registration,
      props: { component: "signup" },
      meta: { showLoginPrompt: false }
    },
    {
      path: "/login",
      component: registration,
      props: { component: "login" },
      meta: { showLoginPrompt: false }
    },
    {
      path: "/profile",
      component: profile,
      meta: { showLoginPrompt: true }
    },
    {
      path: "/event/:id",
      redirect: "/event/:id/home"
    },
    {
      path: "/event/:id",
      component: event,
      props: true,
      meta: { showLoginPrompt: true },
      children: [
        {
          path: "home",
          component: eventHome,
          props: true
        },
        {
          path: "details",
          component: eventDetails,
          props: true
        },
        {
          path: "sessions",
          component: eventSessions,
          props: true
        },
        {
          path: "attendees",
          component: eventAttendees,
          props: true
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js